import React from 'react';
import { Truck } from 'lucide-react';
import { useLang } from '../i18n/LanguageContext';
import { DELIVERY_NOTICE } from '../data/deliveryNotice';

export const DeliveryNotice = ({ className = '' }) => {
  const { lang } = useLang();
  const n = DELIVERY_NOTICE[lang] || DELIVERY_NOTICE.fr;

  return (
    <div
      className={`flex gap-3 p-4 rounded-xl bg-white/[0.03] border border-white/10 ${className}`}
      data-testid="delivery-notice"
    >
      <Truck className="w-5 h-5 text-purple-400 shrink-0 mt-0.5" />
      <div>
        <p className="text-white text-sm font-semibold mb-1">{n.title}</p>
        <p className="text-gray-400 text-xs leading-relaxed">{n.text}</p>
      </div>
    </div>
  );
};

export default DeliveryNotice;
